// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorsCard-cls1_OIS","cls2":"AuthorsCard-cls2_Eoy AuthorsCard-cls1_OIS","margin":"AuthorsCard-margin_xBA"};